import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleSidebar } from '../../../redux/sidebar/sidebarReducer';
import BurgerIcon from '../../../components/burger-icon/BurgerIcon';

import scss from './BurgerMenuIcon.module.scss';

function BurgerMenuIcon() {
  const dispatch = useDispatch();

  const slimSidebar = useSelector((state) => state.sidebar.slim);

  const handleToggleMenu = () => {
    dispatch(toggleSidebar());
  };

  return (
    <div className={scss.burgerMenuWrapper}>
      <BurgerIcon isOpen={!slimSidebar} onChange={handleToggleMenu} />
    </div>
  );
}

export default BurgerMenuIcon;
